(() => {
  if (window.__accordionSingleOpenInit) return;
  window.__accordionSingleOpenInit = true;

  const CLOSE_DURATION_MS = 500;

  // `toggle` does not bubble, so listen in capture phase to delegate.
  document.addEventListener(
    'toggle',
    (event) => {
      const details = event.target;
      if (!(details instanceof HTMLDetailsElement)) return;
      if (!details.open) return;

      const container = details.closest('.accordion[data-single-open="true"]');
      if (!container) return;

      const openSiblings = container.querySelectorAll('details[open]');
      openSiblings.forEach((other) => {
        if (other === details) return;
        const customEl = other.closest('accordion-custom');
        if (customEl) {
          customEl.classList.add('is-closing');
          setTimeout(() => customEl.classList.remove('is-closing'), CLOSE_DURATION_MS);
        }
        other.open = false;
      });
    },
    true
  );
})();
